import { render, staticRenderFns } from "./MppFileFolder.vue?vue&type=template&id=26b5135a&scoped=true"
import script from "./MppFileFolder.vue?vue&type=script&lang=js"
export * from "./MppFileFolder.vue?vue&type=script&lang=js"
import style0 from "./MppFileFolder.vue?vue&type=style&index=0&id=26b5135a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b5135a",
  null
  
)

export default component.exports